import { theme, ThemeConfig } from 'antd';

const { defaultAlgorithm } = theme;

export const themeColors = {
  primary: '#da2e9a',
  lightPrimary: '#ea57b3',
  darkPrimary: '#c52489',

  secondary: '#232567',

  outline: 'rgba(62, 87, 123, 0.1)',

  disabledBackground: '#f2eef3',

  blue: '#007ae7',
  lightBlue: '#ebf5fd',

  error: '#ff634e',

  gray: 'var(--gray)',
  lightGray: 'var(--light-gray)',
  whiteGray: 'var(--white-gray)',
} as const;

export const defaultTheme: ThemeConfig = {
  algorithm: defaultAlgorithm,
  token: {
    // colorPrimary: themeColors.primary,
    colorText: themeColors.secondary,
    colorBorder: themeColors.gray,
    colorTextPlaceholder: themeColors.gray,
    controlOutline: themeColors.outline,
    controlHeight: 36,
    controlHeightLG: 44,
    controlHeightSM: 30,
  },
  components: {
    Button: {
      colorPrimary: themeColors.primary,
      colorPrimaryBgHover: themeColors.lightPrimary,
      colorPrimaryHover: themeColors.lightPrimary,
      colorPrimaryActive: themeColors.darkPrimary,

      // colorLink: themeColors.primary,

      controlHeight: 32,
      borderRadius: 4,
    },
    Input: {
      colorPrimary: themeColors.secondary,
      colorPrimaryHover: themeColors.secondary,
      controlOutline: themeColors.outline,
      colorText: themeColors.secondary,
      colorTextDisabled: themeColors.secondary,
      colorBgContainerDisabled: themeColors.disabledBackground,

      colorError: themeColors.error,
      colorErrorBg: themeColors.error,
      colorErrorText: themeColors.error,
      colorErrorOutline: themeColors.error,
      colorErrorBorder: themeColors.error,
    },
    DatePicker: {
      colorPrimary: themeColors.secondary,
      colorPrimaryHover: themeColors.secondary,
      controlOutline: themeColors.outline,
      colorBgContainerDisabled: themeColors.disabledBackground,
    },
    Select: {
      colorPrimary: themeColors.secondary,
      colorPrimaryHover: themeColors.secondary,
      colorTextDisabled: themeColors.gray,
      controlOutline: themeColors.outline,
      colorBgContainerDisabled: themeColors.disabledBackground,
    },
    Form: {},
    Breadcrumb: {
      fontSize: 16,
      controlItemBgHover: 'transparent',
    },
    Switch: {
      colorPrimary: themeColors.primary,
      colorPrimaryHover: themeColors.lightPrimary,
    },
    Notification: {},
  },
};
